module.exports = __webpack_public_path__ + "static/media/广州大屏.678772d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mov/广州大屏.mp4
// module id = D3s1
// module chunks = 1